// @flow
import { ID_FONTE_FIDC_PADRAO, type MedidaSelecionada } from "../../../model";
import { type State, analiseValorDaMedida } from "../../../state";

export const processarSeriesComFonte = (
  state: State,
  medidas: Array<MedidaSelecionada>
): Array<MedidaSelecionada> => {
  return medidas.map(medida => {
    return {
      ...medida,
      fonteDeDadosFIDC: ID_FONTE_FIDC_PADRAO,
      ...analiseValorDaMedida(medida, state),
    };
  });
};

const SeriesComFonte = () => {
  return null;
};

export default SeriesComFonte;
